import { Dispatch, SetStateAction } from 'react';

import dynamic from 'next/dynamic';

import { useDevice } from '@contexts/device';
import { HotelDetailViewModel, HotelViewModel } from '@api/v3';

const DesktopDifference = dynamic(() => import('./DesktopDifference'), {
  ssr: false,
});

const MobileDifference = dynamic(() => import('./MobileDifference'), {
  ssr: false,
});

const Difference = ({
  diffData,
  differenceItem,
  setDiffData,
  addDiffData,
  removeDiffData,
  isListing,
  setIsRedirecting,
}: {
  differenceItem: HotelViewModel | HotelDetailViewModel;
  diffData: any[];
  setDiffData: Dispatch<SetStateAction<any[]>>;
  addDiffData: (item: any) => void;
  removeDiffData: (index: number) => void;
  isListing: boolean;
  setIsRedirecting?: (isRedirecting: boolean) => void;
}) => {
  const { isDesktop } = useDevice();
  return isDesktop ? (
    <DesktopDifference
      diffData={diffData}
      differenceItem={differenceItem}
      setDiffData={setDiffData}
      addDiffData={addDiffData}
      removeDiffData={removeDiffData}
      isListing={isListing}
      setIsRedirecting={setIsRedirecting}
    />
  ) : (
    <MobileDifference
      diffData={diffData}
      differenceItem={differenceItem}
      setDiffData={setDiffData}
      addDiffData={addDiffData}
      removeDiffData={removeDiffData}
      isListing={isListing}
      setIsRedirecting={setIsRedirecting}
    />
  );
};

export default Difference;
